import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SideNavigation from '@amzn/awsui-components-console/side-navigation';
import './SideNavigation.scss';

const PortalSideNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <SideNavigation
      activeHref={location.pathname}
      header={{
        href: '/',
        text: 'GCR Content Portal',
      }}
      onFollow={(event) => {
        event.preventDefault();
        navigate(event.detail.href);
      }}
      items={[
        { type: 'link', text: 'Home', href: '/' },
        { type: 'link', text: 'Collections', href: '/collections' },
        { type: 'link', text: 'Applications', href: '/applications' },
        { type: 'divider' },
        {
          type: 'section',
          text: 'Tools',
          items: [{ type: 'link', text: 'HTML Editor', href: '/html-editor' }],
        },
      ]}
    />
  );
};

export default PortalSideNavigation;
